import 'Modernizr';
import 'alpinejs';
import { gsap } from 'gsap';
import { MotionPathPlugin } from 'gsap/MotionPathPlugin.js';

gsap.registerPlugin(MotionPathPlugin);

window.alpine = {
    sunComeUp: function() {
        gsap.to('#sun', {
            duration: 1.6, 
            ease: 'power1.out',
            motionPath:{
                path: '#path',
                align: '#path',
                alignOrigin: [0.5, 0.5],
                start: 1,
                end: 0,
            }
        });
    }
}

window.youtubeLightbox = function() {
	return {
		src: '',
		srcdoc: '',
		modalOpen: false,
		open(src, img) {
			this.modalOpen = true;
			document.querySelector('body').classList.add('no-scroll');
			this.src = `https://www.youtube.com/embed/${src}`;
			this.srcdoc = `<style>*{padding:0;margin:0;overflow:hidden}html,body{height:100%}img,span{position:absolute;width:100%;top:0;bottom:0;margin:auto}span{height:1.5em;text-align:center;font:48px/1.5 sans-serif;color:white;text-shadow:0 0 0.5em black}</style><a href=https://www.youtube.com/embed/${src}?autoplay=1><img src=${img}><span style='color:hsl(21,100%,61%)'><svg width="60" height="60" viewBox="0 0 31 31"><circle fill="#fff" cx="15" cy="15" r="15"/><path fill="#1bb2ad" d="M11 23V7l12 8z"/></svg></span></a>`;
		},
		close() {
			this.modalOpen = false;
			document.querySelector('body').classList.remove('no-scroll');
			this.src = '';
			this.srcdoc = '';
		}
	}
}